import axios from "axios";
import ApiException from "@/services/ApiException";

import config from "@/app.config.json";

const urlBase = `${config.urlApi}`

const urls = {
  obter: `${urlBase}/ParamBoletos`,
  obterId: `${urlBase}/ParamBoletos`,
  adicionar: `${urlBase}/ParamBoletos`,
  alterar: `${urlBase}/ParamBoletos`,
  excluir: `${urlBase}/ParamBoletos`,
  obterOpcoes: `${urlBase}/ParamBoletos/ObterOpcoes`,
};

//TOKEN
function getToken(): string {

  console.log("Pegando o token");
  const x = localStorage.getItem('user');

  if (x != null) {
    const user = JSON.parse(x);

    if (user && user.accessToken) {
      return `Bearer  ${user.accessToken}`;
    } else {
      return "";
    }
  }
  else
    return "";
}

//INTERFACE
export interface IPaginacao<T> {
  dados: T[];
  totalRegistros: number;
}

export interface IParamBoleto {
  paramBoletoId: number,
  tipoCobranca: number,
  layoutRemessa: number,
  cedenteNome: string,
  cedenteTipoInscricao: number,
  cedenteCpfCnpj: string,
  cedenteTipoCarteira: number,
  cedenteTipoDocumento: number,
  cedenteAgencia: string,
  cedenteAgenciaDigito: string,
  cedenteConta: string,
  cedenteContaDigito: string,
  cedenteCodigoTransmissao: string,
  cedenteCodigo: string,
  cedenteConvenio: string,
  cedenteModalidade: string,
  cedenteReponEmissao: number,
  cedenteBairro: string,
  cedenteCidade: string,
  cedenteCep: string,
  layoutImpressao: number,
  tipoChavePix: number,
  chavePix: string,
  carteiraEnvio: number,
  cedenteComplemento: string,
  cedenteLogradouro: string,
  cedenteNumeroRes: string,
  cedenteTelefone: string,
  cedenteUF: string,
  wsClientID: string,
  wsClientSecret: string,
  wsKeyUser: string,
  wsScope: string,
  wsIndicadorPix: boolean,
  wsAmbiente: number,
  wsOperacao: number,
  wsSSLType: number,
  wsSSLHttpLib: number,
  wsTimeOut: number,
  wsArquivoCRT: string,
  wsArquivoKEY: string,
  emailNome: string,
  emailConta: string,
  emailUsuario: string,
  emailSenha: string,
  emailServidor: string,
  emailPorta: number,
  emailSSL: boolean,
  emailTSL: boolean,
  nossoNumSerie: number,
  nossoNumSequencial: number,
}

export interface IEnums {
  ambienteWs: IEnum[],
  layoutRemessa: IEnum[],
  operacao: IEnum[],
  pessoa: IEnum[],
  responEmissao: IEnum[],
  sslHttpLib: IEnum[]
  sslTypeienteWs: IEnum[],
  tipoCarteira: IEnum[],
  tipoCobranca: IEnum[],
  tipoDocumento: IEnum[],
  layoutImpressao: IEnum[],
  tiposChavesPix: IEnum[],
  tiposEnvioCarteira: IEnum[],
  estados: IEnum[],
}

export interface IEnum {
  valor: string,
  texto: string
  posicao: number
}


//MÉTODOS
export const obter = (): Promise<IPaginacao<IParamBoleto>> => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(urls.obter)
      .then((r) => {
        return resolve(r.data);
      })
      .catch((error) => {
        return reject(new ApiException(error || "Erro ao obter configuração "));
      });
  });
};

export const obterId = (id: number): Promise<IParamBoleto> => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common.Authorization = getToken();

    axios
      .get(urls.adicionar + `/${id}`)
      .then((r) => {
        return resolve(r.data);
      })
      .catch((error) => {
        return reject(new ApiException(error || "Erro ao obter configuração  por Id"));
      });
  });
};

export const adicionar = (dados: IParamBoleto): Promise<IParamBoleto> => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common.Authorization = getToken();

    axios
      .post(urls.adicionar, dados)
      .then((r) => {
        return resolve(r.data);
      })
      .catch((error) => {
        return reject(new ApiException(error || "Erro ao adicionar configuração "));
      });
  });
};

export const alterar = (params: IParamBoleto): Promise<IParamBoleto> => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common.Authorization = getToken();

    axios
      .put(urls.alterar + `/${params.paramBoletoId}`, params)
      .then((r) => {
        return resolve(r.data);
      })
      .catch((error) => {
        return reject(new ApiException(error || "Erro ao alterar configuração "));
      });
  });
};

export const deletar = (id: number): Promise<IParamBoleto> => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common.Authorization = getToken();

    axios
      .delete(urls.excluir + `/${id}`)
      .then((r) => {
        return resolve(r.data);
      })
      .catch((error) => {
        return reject(new ApiException(error || "Erro ao deletar configuração "));
      });
  });
};

export const obterOpcoes = (): Promise<IEnums> => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common.Authorization = getToken();

    axios
      .post(urls.obterOpcoes)
      .then((r) => {
        return resolve(r.data)
      })
      .catch((error) => {
        return reject(new ApiException(error || "Erro ao adicionar configuração "));
      });
  });
};